import { module } from 'angular';
import App from '../../../app';

class SCR0708Controller {
	
	constructor ($scope, $uibModalInstance, $timeout, httpService, utilService, codeService, gridService, popupService, data){
		this.$scope = $scope;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.codeService = codeService;
		this.data = data;
		this.codes = codeService.commonCodes;
		
		this.initWindow(960, 640);
		this.initText();
		
		this.$timeout(() => {
			this.initGridOption();
			this.getDetailGrid(this.data.reqData);
			this.setDeployDscd();
		});
	}
	
	setDeployDscd() {
		let txt = '';
		
		if(this.data.reqData.deployResultCd.indexOf('SUCCESS') !== -1) {
			if(this.data.reqData.deployResultCd.indexOf('_') !== -1) {
				txt = this.text.redeploy;
			}else{
				txt = this.text.deploy;
			}
		}else{
			if(this.data.reqData.deployResultCd.indexOf('_') !== -1) {
				txt = this.text.redeployFail;
			}else{
				txt = this.text.deployFail;
			}
		}
		
		this.deployDesd = txt;
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = $.extend({}, bxMsg.getMessages('common'), bxMsg.getMessages('manageMciInterface'));	
	}
	
	initGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setCheckBar({visible: false});
		this.gridView.setDisplayOptions({fitStyle: 'evenFill', vscrollBar: true}); 
		
		this.dataProvider.setFields([
    		 {fieldName: "systemCd"}, {fieldName: "systemNm"}, {fieldName: "systemUrl"}, 
    		 {fieldName: "deployStatus"}, {fieldName: "message"}
        ]);
		
		this.gridView.setColumns([
			{ name: "systemCd", fieldName: "systemCd", header : { text: this.text.sysCd } , width: 100, styles: { textAlignment: 'center' } },
			{ name: "systemNm", fieldName: "systemNm", header : { text: this.text.sysNm }, width: 100, styles: { textWrap: 'ellipse' } },
			{ name: "systemUrl", fieldName: "systemUrl", header : { text: this.text.deployUrl }, width: 100, styles: { textWrap: 'ellipse' } },
			{ 
				name: "deployStatus", fieldName: "deployStatus", header : { text: this.text.deployResultCd }, width: 100, styles: { textAlignment: 'center' },
				dynamicStyles: [				
					{
						criteria: 'value = "FAIL"',
						styles: {foreground: '#ff4526'}
				}]
			}
		]);
		
		this.gridView.onDataCellClicked = (grid, itemIndex, checked) => {
			this.selectedIntrfcdeploysysdtDto = grid.getValues(itemIndex.itemIndex);
			this.$scope.$apply();
		};
	}

	getDetailGrid(reqData) {
		this.httpService.get(`/intrfccoms/deployhistoryresults?`, reqData).then(res => {
			this.dataProvider.setRows(res.intrfcDeployResponseList);
		});
	}
		
	closeModal(isOk){
		this.$uibModalInstance.dismiss();
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
}

module(App.name).controller('SCR0708Controller', SCR0708Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR0708/SCR0708.controller.js